module.exports = __webpack_public_path__ + "img/deco_06.725aed02.png";